import { commonjsGlobal as e } from "./index168.js";
import { __exports as E } from "./index189.js";
import m from "react";
import { c as T } from "./index199.js";
(function(o) {
  var n = e && e.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), o.returnFirstArg = o.canTextBeChildOfNode = o.ELEMENTS_WITH_NO_TEXT_CHILDREN = o.PRESERVE_CUSTOM_ATTRIBUTES = void 0, o.isCustomComponent = s, o.setStyleProp = u;
  var a = m, f = n(T), i = /* @__PURE__ */ new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
  ]);
  function s(t, r) {
    return t.includes("-") ? !i.has(t) : !!(r && typeof r.is == "string");
  }
  var _ = {
    reactCompat: !0
  };
  function u(t, r) {
    if (typeof t == "string") {
      if (!t.trim()) {
        r.style = {};
        return;
      }
      try {
        r.style = (0, f.default)(t, _);
      } catch {
        r.style = {};
      }
    }
  }
  o.PRESERVE_CUSTOM_ATTRIBUTES = Number(a.version.split(".")[0]) >= 16, o.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
  ]);
  var c = function(t) {
    return !o.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(t.name);
  };
  o.canTextBeChildOfNode = c;
  var l = function(t) {
    return t;
  };
  o.returnFirstArg = l;
})(E);
